import Base from "@/api/Base";

export default class Rating extends Base
{
	setJobProfileId (v)
	{
		this.jobProfileId = v;
		return this;
	}

	setRating (v)
	{
		this.data.rating = v;
		return this;
	}

	getMethod ()
	{
		return 'PUT';
	}

	getUrl ()
	{
		return '/kandidat/stellenprofil/' + this.jobProfileId + '/bewertung';
	}
}
